var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertCircleTrimmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FEE4E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2107_100280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 15.25C12.8995 15.25 15.25 12.8995 15.25 10C15.25 7.10051 12.8995 4.75 10 4.75C7.10051 4.75 4.75 7.10051 4.75 10C4.75 12.8995 7.10051 15.25 10 15.25Z",
    stroke: "#F04438",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.375C10.4142 13.375 10.75 13.0392 10.75 12.625C10.75 12.2108 10.4142 11.875 10 11.875C9.58579 11.875 9.25 12.2108 9.25 12.625C9.25 13.0392 9.58579 13.375 10 13.375Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7V10.375",
    stroke: "#F04438",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_100280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleTrimmed);
export default __webpack_public_path__ + "static/media/alert-circle-trimmed.b8008ea6d7b2c4d4e19f59998366e267.svg";
export { ForwardRef as ReactComponent };